import { Table, Card, Button, message, Spin, Input } from "antd";
import { useState } from "react";
import { SearchOutlined, ReloadOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import MotionHoc from "../../../utils/MotionHoc";
import {
  HEADERS_EXPORT_BEN,
  POST_MAIN_REFINACE_ENFORCE,
} from "../../API/apiUrls";
import axios from "axios";
import ReBalanceFinance from "./modal/ReBalanceFinance";

const OPTIONS_CASE_TYPE = [
  { value: 1, icon: "🤝", label: "ทำยอม" },
  { value: 2, icon: "⚖️", label: "พิพากษามีดิว" },
];

const formatMoney = (v) =>
  v === null || v === undefined || v === ""
    ? "-"
    : Number(v).toLocaleString("th-TH");

const formatThaiDate = (v) =>
  v ? dayjs(v).add(543, "year").format("D MMM YY") : "-";

// สร้าง key ของแถวแบบเดียวกับ rowKey ของตาราง เพื่อไม่ให้สถานะแก้ไขชนกันเมื่อ idQueue ไม่มีค่า
const getRowKey = (r) => r.idQueue ?? r.key;

const Main = () => {
  const userId = parseInt(localStorage.getItem("USER_ID"));
  const [dataArr, setDataArr] = useState([]);
  const [loading, setLoading] = useState(false);
  const [caseType, setCaseType] = useState(null);
  const [searchInputTable, setSearchInputTable] = useState("");
  const [isModal, setIsModal] = useState(false);
  const [dataRec, setDataRec] = useState(null);

  // ── Load ──────────────────────────────────────────────────
  const loadMainData = async (type = caseType, search = searchInputTable) => {
    // if (!search.trim()) {
    //   message.warning("กรุณากรอกเลขสัญญา");
    //   return;
    // }
    setLoading(true);
    try {
      const res = await axios.post(
        POST_MAIN_REFINACE_ENFORCE,
        {
          userId: 1,
          search: search.trim(),
          flagLoanNew: type,
        },
        { headers: HEADERS_EXPORT_BEN },
      );
      if (res.status === 200) {
        if (res.data.success === "ไม่พบข้อมูล") {
          message.warning("ไม่พบข้อมูล");
          setDataArr([]);
          return;
        }
        const newData = (res.data?.data ?? []).map((item, i) => ({
          ...item,
          key: i + 1,
        }));
        setDataArr(newData);
      } else {
        message.error("ไม่มีข้อมูล");
        setDataArr([]);
      }
    } catch (err) {
      console.error(err);
      message.error(`ไม่พบข้อมูล: ${err.message}`);
      setDataArr([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = () => {
    loadMainData(caseType, searchInputTable);
  };

  // ── Columns ───────────────────────────────────────────────
  const columns = [
    {
      title: "ลำดับ",
      key: "index",
      align: "center",
      width: 60,
      render: (_, __, idx) => idx + 1,
    },
    {
      title: "เลขสัญญา",
      key: "contno",
      align: "center",
      width: 130,
      render: (_, r) => (
        <div style={{ textAlign: "center" }}>
          <div>{r.newContno ?? "-"}</div>
          {r.CONTNO && r.CONTNO !== r.newContno && (
            <div style={{ fontSize: 11, color: "#999" }}>เดิม {r.CONTNO}</div>
          )}
        </div>
      ),
    },
    {
      title: "ชื่อ-นามสกุล",
      key: "fullName",
      align: "left",
      width: 180,
      render: (_, r) => (
        <>
          <div>{r.fullName ?? "-"}</div>
          <div style={{ fontSize: 11, color: "#999" }}>{r.CUSCOD ?? "-"}</div>
        </>
      ),
    },
    {
      title: "ยอดตามคำพิพากษา",
      dataIndex: "totalJugde",
      key: "totalJugde",
      align: "right",
      width: 130,
      render: (v) => formatMoney(v),
    },
    {
      title: "ยอดหนี้คงเหลือ",
      dataIndex: "balance",
      key: "balance",
      align: "right",
      width: 120,
      render: (v) => formatMoney(v),
    },

    {
      title: "เลขคดี (ดำ/แดง)",
      key: "caseNumber",
      align: "center",
      width: 150,
      render: (_, r) => (
        <div style={{ textAlign: "center", fontSize: 12 }}>
          <div>ดำ {r.blackCaseNumber ?? "-"}</div>
          <div>แดง {r.redCaseNumber ?? "-"}</div>
          <div>วันที่พิพากษา {formatThaiDate(r.judgeDate) ?? "-"}</div>
        </div>
      ),
    },

    {
      title: "การจัดการ",
      key: "actions",
      align: "center",
      width: 170,
      render: (_, r) => {
        return (
          <Button
            onClick={() => {
              setDataRec(r);
              setIsModal(true);
            }}
            disabled={r.idRequest}
          >
            อัพเดทข้อมูล
          </Button>
        );
      },
    },
  ];

  return (
    <>
      {/* ── Search Bar ── */}

      <Card
        style={{
          marginBottom: 8,
          borderRadius: 12,
          border: "1px solid #ffcb05",
          background: "#fffdf0",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            flexWrap: "wrap",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              padding: "6px 12px",
              borderRadius: 8,
              background: "#fff3cc",
              border: "1px solid #ffcb05",
              whiteSpace: "nowrap",
            }}
          >
            <span style={{ fontSize: 14, color: "#efa420" }}>🔍</span>
            <span style={{ fontSize: 13, fontWeight: 500, color: "#efa420" }}>
              เลือกประเภท
            </span>
          </div>

          <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
            {OPTIONS_CASE_TYPE.map(({ value, icon, label }) => {
              const isActive = caseType === value;
              return (
                <button
                  key={value}
                  onClick={() => {
                    setCaseType(value);
                    // loadMainData(value);
                  }}
                  disabled={loading}
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 5,
                    padding: "6px 14px",
                    borderRadius: 20,
                    border: `1.5px solid ${isActive ? "#efa420" : "#d9d9d9"}`,
                    background: isActive
                      ? "linear-gradient(135deg, #ffcb05, #efa420)"
                      : "#fff",
                    color: isActive ? "#fff" : "#555",
                    fontWeight: isActive ? 600 : 400,
                    fontSize: 13,
                    cursor: loading ? "not-allowed" : "pointer",
                    opacity: loading ? 0.6 : 1,
                    boxShadow: isActive
                      ? "0 2px 8px rgba(239,164,32,0.45)"
                      : "none",
                    transition: "all 0.2s",
                    whiteSpace: "nowrap",
                  }}
                >
                  <span>{icon}</span>
                  <span>{label}</span>
                  {isActive && dataArr.length > 0 && (
                    <span
                      style={{
                        marginLeft: 4,
                        background: "rgba(255,255,255,0.35)",
                        borderRadius: 10,
                        padding: "0 6px",
                        fontSize: 11,
                        fontWeight: 700,
                        color: "#fff",
                      }}
                    >
                      {dataArr.length}
                    </span>
                  )}
                </button>
              );
            })}
          </div>

          <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
            <Input.Search
              placeholder="ค้นหาสัญญา"
              value={searchInputTable}
              onChange={(e) => setSearchInputTable(e.target.value)}
              onSearch={handleSearch}
              loading={loading}
              allowClear
              size="large"
              style={{ width: "100%" }}
              enterButton={
                <span>
                  <SearchOutlined /> ค้นหา
                </span>
              }
            />
          </div>

          {loading && (
            <span
              style={{
                marginLeft: "auto",
                color: "#efa420",
                fontSize: 12,
                whiteSpace: "nowrap",
              }}
            >
              ⏳ กำลังโหลด...
            </span>
          )}
        </div>
      </Card>

      <Card>
        <Spin spinning={loading} size="large" tip="Loading...">
          <Table
            size="small"
            columns={columns}
            dataSource={dataArr}
            rowKey={getRowKey}
            scroll={{ x: "max-content" }}
            pagination={{
              defaultPageSize: 20,
              showSizeChanger: true,
              showTotal: (t) => `ทั้งหมด ${t} รายการ`,
            }}
            footer={() => (
              <span>จำนวนสัญญาทั้งหมด {dataArr.length} รายการ</span>
            )}
          />
        </Spin>
        {isModal && (
          <ReBalanceFinance
            open={isModal}
            close={setIsModal}
            dataDefault={dataRec}
            onSuccess={loadMainData}
          />
        )}
      </Card>
    </>
  );
};

const MainRefinaceEnforce = MotionHoc(Main);
export default MainRefinaceEnforce;
